import { PosDataLevel } from '@/domain/models/Pos';
import { Prefecture } from '@/domain/models/Store';

export interface Enterprise {
  enterprise_id: number;
  enterprise_name: string;
  brands: Brand[];
  providers: Provider[];
}

interface Brand {
  brand_id: number;
  brand_name: string;
  stores: Store[];
}

interface Store {
  master_store_id: number;
  store_name: string;
  prefecture: Prefecture | '';
  city: string;
  auth_store_id: number;
  auth_store_name: string;
  is_franchise: boolean;
}

interface Provider {
  provider_id: number;
  provider_name: string;
  pos_data_level: PosDataLevel;
}

export const searchProviderFromName = (
  enterprise: Enterprise,
  provider_name: string
): Provider | undefined => {
  const provider = enterprise.providers.find(
    (provider) => provider.provider_name === provider_name
  );
  return provider;
};
